import React from 'react'

const PackageShipment = () => {
  return (
    <div className='mx-auto p-4'>
      PackageShipment
    </div>
  )
}

export default PackageShipment
